export interface ApiGetDisclosureTitleRequest {
    task_id: string;
    current_step: string;
}

export const GetDisclosureTitle = Symbol('GetDisclosureTitle');

export interface GetDisclosureTitle {
    getDisclosureTitle(data: ApiGetDisclosureTitleRequest): Promise<string>;
}
